import { environment } from 'src/environments/environment';
import { UserService } from '../../../core/services/user.service';

/**
 * Whether the Messages CONTENT is enabled for the current user.
 * Feature: 019-message-center (Phase 5).
 *
 * Mirrors EXACTLY the route gate predicate (`featureMatchGuard('messages')` in
 * app.routes.ts): the gitignored local-dev override OR the real `messages` Auth0
 * feature flag. When this is false the user only ever sees the FeaturePlaceholder,
 * so the unread badge MUST stay hidden — there is no real count to show.
 *
 * The nav entry itself is always visible (mirrors Care+); only the badge is
 * gated by this predicate.
 *
 * @param userService - The app's UserService (for the real feature-flag check).
 * @returns true when the Messages section renders real content for this user.
 */
export function isMessagesContentEnabled(userService: UserService): boolean {
  if ((environment as { devOverrideMessagesFlag?: boolean }).devOverrideMessagesFlag === true) {
    return true;
  }
  return userService.isFeatureEnabled('messages');
}
